var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.47703 9.04973C6.77346 9.04973 7.01377 8.8095 7.01377 8.51317C7.01377 8.21683 6.77346 7.97661 6.47703 7.97661C6.1806 7.97661 5.94029 8.21683 5.94029 8.51317C5.94029 8.8095 6.1806 9.04973 6.47703 9.04973Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01535 3.68412H5.94188V7.44005H7.01535V3.68412Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0794 7.95237L8.32059 1.52675C7.94323 0.872564 7.23989 0.466529 6.47925 0.465639C5.71853 0.464748 5.01494 0.869108 4.63288 1.52678L0.872697 7.95476C0.482792 8.61036 0.473971 9.43187 0.851638 10.1018C1.22962 10.7724 1.93736 11.1897 2.70718 11.1959L10.2394 11.196C11.0172 11.1884 11.7236 10.7724 12.1015 10.1025C12.479 9.4333 12.4705 8.61362 12.0794 7.95237ZM1.79701 8.49994L5.55998 2.06722C5.75055 1.73919 6.10006 1.53832 6.47799 1.53876C6.85588 1.5392 7.20526 1.7409 7.39267 2.06578L11.1544 8.49648C11.3516 8.82982 11.3558 9.24018 11.1668 9.5752C10.9776 9.9107 10.6238 10.1191 10.2341 10.1229L2.71155 10.1228C2.33027 10.1197 1.97576 9.9107 1.78647 9.57489C1.59738 9.23945 1.6018 8.82819 1.79701 8.49994Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.035e2bf8.svg";
export { ForwardRef as ReactComponent };